import React from 'react'
import { getInitMarketingData } from 'common/utils/headers'
import type { primitives } from '@adc/blueprint'
import { useApplicationContext } from '@adc/ui-adc'
import { CombinedListingType } from 'common/context/listing'

interface AdGlareProviderProps {
  listing: CombinedListingType
}

type AuctionUser = primitives.AuctionUser
const AdvertisementMarketingScript = ({ listing }: AdGlareProviderProps) => {
  const { user } = useApplicationContext()

  const initMarketingData = getInitMarketingData({
    // @ts-ignore listings are compatible
    listing,
    user: user as AuctionUser,
  })

  return <script dangerouslySetInnerHTML={{ __html: initMarketingData }} />
}

export default AdvertisementMarketingScript
